import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Grid,
  IconButton,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import PhoneInput from "react-phone-input-2";
import { useDispatch, useSelector } from "react-redux";
import GlobalButton from "../../../components/CustomButton";
import CustomDropDown from "../../../components/CutomDropDown";
import Label from "../../../components/Label";
import Loader from "../../../components/Loader";
import SnackbarAlert from "../../../components/SnackBar";
import TextInput from "../../../components/TextInputs";
import appcolors from "../../../constants/Colors";
import globalStyle from "../../../globalStyle";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import AppContainer from "./../../../components/AppContainer/index";
import { allImages } from "../../../assets";
import { helper } from "../../../helper/uploader";

function Profile({ handleNextStep, branchData }) {
  console.log(branchData, "branchDatabranchDatabranchData");

  const shopType = ["Spa", "Saloon", "Both"];
  const activeTab = useSelector((state) => state.activeTab.tabs);
  const { user } = useSelector((state) => state.user);

  const dispatch = useDispatch();
  const imgRefrence = useRef(null);
  const logoImg = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  const [inputVal, setInputVal] = useState({
    branchName: "",
    businessName: "",
    contactNumber: "",
    logoImage: "",
    description: "",
    email: "",
    password: "",
    type: "",
    images: [],
  });

  const [error, setError] = useState({
    branchName: false,
    businessName: false,
    contactNumber: false,
    description: false,
    email: false,
    password: false,
    type: false,
    images: false,
    logoImage: false,
  });

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  useEffect(() => {
    setInputVal({
      branchName: user?.branchName,
      businessName: user?.businessName,
      contactNumber: user?.contactNumber,
      logoImage: user?.logoImage,
      description: user?.description,
      email: user?.companyEmail,
      type: user?.type,
      images: user?.businessProfileImages,
    });
  }, [branchData]);
  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, client_setting: tab }));
  };

  const handleFileUpload = async (e, type) => {
    try {
      const file = e.target.files[0];
      let result = await helper.uploadMediaService(file);
      if (result) {
        if (type === "logo") {
          setInputVal((prev) => ({
            ...prev,
            logoImage: result,
          }));
        } else if (type === "images") {
          setInputVal((prev) => ({
            ...prev,
            images: [...(prev.images || []), result],
          }));
        }
      }
    } catch (error) {
      console.error("Image upload failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Ensure logoImage is uploaded as a single file
  const handleUploadLogoImg = (e) => {
    handleFileUpload(e, "logo");
  };

  // Allow multiple images for business profile
  const handleUploadImage = (e) => {
    handleFileUpload(e, "images");
  };

  const handleRemoveImage = (index) => {
    setInputVal((prev) => {
      const newImages = [...prev.images];
      newImages.splice(index, 1);
      return {
        ...prev,
        images: newImages,
      };
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputVal({ ...inputVal, [name]: value });
  };

  const handlePhoneChange = (phone) => {
    setInputVal({ ...inputVal, contactNumber: phone });
  };

  const handleFormSubmit = async () => {
    // const hasError = branchCreateValidation(inputVal, setError, branchData);

    // if (hasError) {
    //   handleSnackbarVal(
    //     true,
    //     "error",
    //     "Please fill out all required fields correctly."
    //   );
    //   return;
    // }

    let params = {
      timmings: user?.timmings,
      location: user.location,
      businessName: inputVal.businessName,
      branchName: inputVal.branchName,
      email: inputVal.email,
      contactNumber: inputVal.contactNumber,
      logoImage: inputVal.logoImage,
      password: inputVal.password,
      type: inputVal.type,
      images: inputVal.images,
      description: inputVal.description,
      submitType: "edit",
    };
    console.log(params, "paramsparams");

    handleNextStep(params, "profile");
    handleChangeTab("businessAddress");
  };

  const handleChangeValues = (event) => {
    const { name, value } = event.target;
    setInputVal((pre) => ({ ...pre, [name]: value }));
  };

  const renderRightPart = () => {
    return (
      <Stack
        gap={2}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <GlobalButton
          variant={"contained"}
          btnText={"Next Step"}
          handleClickBtn={handleFormSubmit}
          styleProps={{
            height: 40,
            width: "auto",
            fontWeight: 400,
            fontSize: "0.875rem",
          }}
        />
      </Stack>
    );
  };

  return (
    <AppContainer
      primaryHeading={"Add your business info"}
      secondaryHeading={
        "Add key details about your business to display on your online booking profile."
      }
      headProps={renderRightPart()}
      childrenProps={{
        sx: {
          padding: { xs: "10px 20px", md: "20px 50px" },
          paddingBottom: "50px !important",
        },
      }}
    >
      <Loader isLoading={isLoading} />
      <SnackbarAlert
        handleCloseSnackbar={handleCloseSnackbar}
        snackbarProps={snackbarProps}
      />

      <Typography
        mt={3}
        mb={1}
        variant="h1"
        fontSize={"1.125rem"}
        fontWeight={600}
      >
        {/* Basic Information */}
      </Typography>

      <Grid container spacing={2} my={2}>
        <Grid item md={12} xs={12}>
          <Typography
            variant="h1"
            fontSize={"1.125rem"}
            fontWeight={600}
            mr={3}
          >
            Upload logo image
          </Typography>
          {error?.logoImage && (
            <Label
              labelText="Logo Image is required"
              labelProps={{ color: appcolors.red }}
            />
          )}
          {inputVal?.logoImage && (
            <Box mt={2} sx={{ position: "relative", display: "inline-block" }}>
              <Box
                height={120}
                width={120}
                borderRadius={100}
                overflow={"hidden"}
                sx={{
                  cursor: "pointer",
                  position: "relative",
                }}
              >
                <img
                  src={inputVal?.logoImage}
                  width={"100%"}
                  height={"100%"}
                  style={{ objectFit: "fill" }}
                  alt="uploaded"
                />
              </Box>
              <IconButton
                sx={{
                  position: "absolute",
                  top: -5,
                  right: -5,
                  backgroundColor: "white",
                }}
                size="small"
                onClick={() =>
                  setInputVal((prev) => ({
                    ...prev,
                    logoImage: "",
                  }))
                }
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
          )}
          {!inputVal?.logoImage && (
            <Box
              onClick={() => logoImg.current.click()}
              height={120}
              width={120}
              borderRadius={100}
              overflow={"hidden"}
              mt={2}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              fontSize={22}
              fontWeight={7000}
            >
              <img
                src={allImages.uploadDumyImage}
                style={{
                  width: "60%",
                  objectFit: "",
                }}
              />
            </Box>
          )}
          <input
            ref={logoImg}
            type="file"
            onChange={handleUploadLogoImg}
            accept="image/*"
            style={{ display: "none" }}
          />
        </Grid>
        <Grid item xs={12} sm={8} md={12}>
          <Stack gap={1}>
            <Typography
              variant="h1"
              fontSize={"1.125rem"}
              fontWeight={600}
              mr={3}
            >
              {/* Business Images */}
            </Typography>

            <Stack direction={"row"} gap={2} alignItems={"center"}>
              {inputVal?.images?.map((val, ind) => (
                <Box
                  key={ind}
                  sx={{ position: "relative", display: "inline-block" }}
                >
                  <Box
                    height={62}
                    width={62}
                    sx={{
                      cursor: "pointer",
                      borderBottom: val ? `5px solid #000` : "none",
                      position: "relative",
                    }}
                  >
                    <img
                      src={val}
                      width={"100%"}
                      height={"100%"}
                      style={{ objectFit: "fill" }}
                      alt="uploaded"
                    />
                  </Box>
                  <IconButton
                    sx={{
                      position: "absolute",
                      top: -5,
                      right: -5,
                      backgroundColor: "white",
                    }}
                    size="small"
                    onClick={() => handleRemoveImage(ind)}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Box>
              ))}
              <Box
                onClick={() => imgRefrence.current.click()}
                height={67}
                width={67}
                borderRadius={3}
                bgcolor={appcolors.primaryLight}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                fontSize={22}
                fontWeight={7000}
              >
                +
              </Box>
            </Stack>
            <input
              ref={imgRefrence}
              type="file"
              onChange={handleUploadImage}
              accept="image/*"
              // multiple
              style={{ display: "none" }}
            />
          </Stack>
        </Grid>
        <Grid item xs={12} md={4}>
          <Label labelText="Branch name" required />
          <TextInput
            name="branchName"
            value={inputVal.branchName}
            onChange={handleInputChange}
            styleProps={globalStyle.textField}
            placeholder={"e.g hair cut"}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Label labelText="Business name" required />
          <TextInput
            name="businessName"
            value={inputVal.businessName}
            onChange={handleInputChange}
            styleProps={globalStyle.textField}
            placeholder={"e.g hair cut"}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <Label labelText="Description" required />
          <TextInput
            name="description"
            value={inputVal.description}
            onChange={handleInputChange}
            styleProps={globalStyle.textField}
            placeholder={"Description"}
            type={"text"}
            multiline={true}
            rows={4}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} my={2}>
        <Grid item xs={12} md={4}>
          <Label labelText="Contact number" required />
          <PhoneInput
            country={"us"}
            inputClass="cutom-phone-input-grey"
            buttonClass="custom-phone-input-button"
            value={inputVal.contactNumber}
            onChange={handlePhoneChange}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Label labelText="Branch Manager Email Address" required />
          <TextInput
            name="email"
            value={inputVal.email}
            onChange={handleInputChange}
            styleProps={globalStyle.textField}
            placeholder={"e.g kamranqadeer@gmail.com"}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <Grid item xs={12}>
            <Stack
              mb={"5px"}
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Label
                labelText="Type"
                htmlFor={"type"}
                required
                labelProps={{ marginBottom: 0 }}
              />
              <Label
                labelText="Info"
                htmlFor={"type"}
                labelProps={{ marginBottom: 0, fontSize: "0.775rem" }}
              />
            </Stack>

            <CustomDropDown
              sx={{ maxHeight: 40 }}
              styleProps={globalStyle.textField}
              name={"type"}
              value={inputVal.type}
              onChange={handleChangeValues}
            >
              {shopType.map((val, index) => (
                <MenuItem key={index} value={val}>
                  {val}
                </MenuItem>
              ))}
            </CustomDropDown>
          </Grid>
        </Grid>
      </Grid>

      <Stack direction={"row"} alignItems={"center"} mt={3} mb={1}>
        {error?.images && (
          <Label
            labelText="Upload at least one image"
            labelProps={{ color: appcolors.red }}
          />
        )}
      </Stack>
    </AppContainer>
  );
}

export default Profile;
